import "@/App.css";
import { ReactLenis } from "lenis/react";
import ZiEnzi from "@/pages/ZiEnzi";
import NoiseOverlay from "@/components/site/NoiseOverlay";
import Cursor from "@/components/site/Cursor";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <NoiseOverlay />
        <Cursor />
        <ZiEnzi />
      </div>
    </ReactLenis>
  );
}

export default App;
